<div class="cookie-policy-wrapper">
  <div class="cookie-policy-container">

    <header class="policy-header">
      <h1>Cookie <em>Policy</em></h1>
      <div class="meta">
        <span class="site">wedo.itscocchi.it</span>
        <span class="divider">·</span>
        <span class="date">Ultimo aggiornamento: Agosto 2026</span>
      </div>
    </header>

    <div class="policy-content">

      <section>
        <h2>1. Cosa sono i cookie</h2>
        <p>
          I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente
          durante la navigazione. Vengono utilizzati per far funzionare correttamente il sito e
          per migliorare l'esperienza di utilizzo.
        </p>
      </section>

      <section>
        <h2>2. Tipologie di cookie utilizzati</h2>
        <p>
          Il sito <strong>wedo.itscocchi.it</strong> utilizza cookie tecnici e di sessione,
          necessari al corretto funzionamento del sito, per tutti i visitatori. Per gli utenti
          <strong>autenticati</strong> è inoltre attivo un servizio di chat di supporto di terze
          parti (vedi punto 3). Non vengono utilizzati cookie di profilazione o di marketing, né
          strumenti di tracciamento per i visitatori non registrati.
        </p>

        <h3>2.1 Cookie tecnici</h3>
        <p>I cookie tecnici sono indispensabili per il funzionamento del sito e non richiedono
          il consenso dell'utente. Svolgono le seguenti funzioni:</p>
        <ul>
          <li>Gestione della sessione di autenticazione dell'utente</li>
          <li>Mantenimento dello stato di login durante la navigazione</li>
          <li>Garanzia della sicurezza della connessione</li>
          <li>Memorizzazione temporanea delle preferenze essenziali</li>
        </ul>

        <h3>2.2 Cookie di sessione</h3>
        <p>
          I cookie di sessione sono temporanei e vengono eliminati automaticamente alla chiusura
          del browser. Vengono utilizzati per mantenere attiva la sessione dell'utente durante
          la navigazione, evitando di richiedere nuovamente le credenziali ad ogni pagina visitata.
        </p>
      </section>

      <section>
        <h2>3. Cookie di terze parti</h2>
        <p>
          Il sito wedo.itscocchi.it non utilizza strumenti di analisi statistica (come Google
          Analytics), pixel di tracciamento o pulsanti social. Per gli utenti <strong>autenticati</strong>
          è attivo il servizio di chat di supporto <strong>Crisp</strong>, che installa propri cookie
          tecnici per gestire la sessione di chat. Questo servizio viene caricato esclusivamente dopo
          il login e non è presente per i visitatori del sito che non hanno effettuato l'accesso.
        </p>
      </section>

      <section>
        <h2>4. Base giuridica</h2>
        <p>
          L'utilizzo dei soli cookie tecnici e di sessione non richiede il consenso dell'utente,
          in conformità con il <strong>Regolamento (UE) 2016/679 (GDPR)</strong>, il D.Lgs. 196/2003
          (Codice Privacy) come modificato dal D.Lgs. 101/2018, e le Linee Guida del Garante per
          la Protezione dei Dati Personali.
        </p>
      </section>

      <section>
        <h2>5. Come disabilitare i cookie</h2>
        <p>
          L'utente può configurare il proprio browser per bloccare o eliminare i cookie. Si avverte
          tuttavia che la disabilitazione dei cookie tecnici potrebbe compromettere il corretto
          funzionamento del sito, in particolare le funzionalità di accesso e autenticazione.
        </p>
        <ul>
          <li><strong>Google Chrome</strong>: Impostazioni › Privacy e sicurezza › Cookie</li>
          <li><strong>Mozilla Firefox</strong>: Impostazioni › Privacy e sicurezza</li>
          <li><strong>Safari</strong>: Preferenze › Privacy</li>
          <li><strong>Microsoft Edge</strong>: Impostazioni › Cookie e autorizzazioni sito</li>
        </ul>
      </section>

      <section>
        <h2>6. Titolare del trattamento</h2>
        <p>
          Il titolare del trattamento dei dati personali è il soggetto responsabile di
          wedo.itscocchi.it. Per qualsiasi richiesta relativa alla presente Cookie Policy,
          è possibile contattarci tramite i recapiti disponibili nella sezione Contatti del sito.
        </p>
      </section>

      <section>
        <h2>7. Modifiche alla Cookie Policy</h2>
        <p>
          Il titolare si riserva il diritto di modificare la presente Cookie Policy in qualsiasi
          momento, anche in considerazione di variazioni normative. Le modifiche saranno pubblicate
          su questa pagina con indicazione della data di aggiornamento.
        </p>
      </section>

      <div class="policy-footer">
        <p>Questa Cookie Policy è conforme al GDPR (Regolamento UE 2016/679) e alla normativa
          italiana in materia di protezione dei dati personali.</p>
      </div>

    </div>
  </div>
</div>